<template>
  <v-dialog v-model="dialog" max-width="700" persistent transition="dialog-bottom-transition" scrollable>
    <v-card>
      <v-card-title class="pa-0">
        <v-toolbar flat dark color="secondary">
          <v-toolbar-title>Formulir Pendaftaran</v-toolbar-title>
          <v-spacer />
          <v-btn right icon dark @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
      </v-card-title>
      <v-card-text class="pa-0 ma-0">
        <v-stepper v-model="step">
          <v-stepper-header style="box-shadow: none">
            <v-stepper-step :complete="step > 1" step="1"> Data DAPODIK </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="step > 2" step="2"> Data Pelengkap </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="step > 3" step="3"> Konfirmasi Data </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="step === 4" step="4"> Selesai</v-stepper-step>
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content step="1" class="py-0">
              <v-alert class="yellow lighten-4">
                <div class="body-2 mb-1">
                  Pilih Sekolah yang akan Anda wakili sebagai Peserta Program Sekolah Penggerak
                </div>
                <v-autocomplete
                  :items="instansiKasek"
                  item-text="nama"
                  item-value="sekolah_id"
                  v-model="form['sekolah_id']"
                  outlined
                  single-line
                  dense
                  hide-details
                  @input="onChangeSekolah"
                >
                  <template v-slot:selection="data">
                    <v-list-item-content style="width: 100% !important;" class="py-2">
                      <span class="body-1 mb-0 black--text">{{ $getDeepObj(data, 'item.nama') || '-' }}</span>
                      <small class="grey--text">{{ $getDeepObj(data, 'item.m_tugas.keterangan') || '-' }}</small>
                    </v-list-item-content>
                  </template>
                  <template v-slot:item="data">
                    <v-list-item-content class="full-width">
                      <h2 class="subtitle-1">{{ $getDeepObj(data, 'item.nama') || '-' }}</h2>
                      <small class="grey--text">{{ $getDeepObj(data, 'item.m_tugas.keterangan') || '-' }}</small>
                    </v-list-item-content>
                  </template>
                </v-autocomplete>
              </v-alert>
              <template v-if="form['sekolah_id']">
                <div v-if="allowDaftar">
                  <h2 class="black--text">Informasi Dasar</h2>
                  <span>Pastikan jawaban Anda sesuai dengan informasi yang sebenarnya.</span>
                  <div class="my-5 black--text">
                    <ol>
                      <li>
                        Apakah Anda benar menjabat sebagai
                        <strong>{{ $getDeepObj(sekolah, 'm_tugas.keterangan') }}</strong> di
                        <strong>{{ $getDeepObj(sekolah, 'nama') }}?</strong>
                        <div>
                          <v-radio-group v-model="form['status_sesuai']['kasek']" row class="mt-0">
                            <v-radio value="1" color="green">
                              <template v-slot:label>
                                <div><strong class="green--text">Ya</strong></div>
                              </template>
                            </v-radio>
                            <v-radio value="0" color="red">
                              <template v-slot:label>
                                <div><strong class="red--text">Tidak</strong></div>
                              </template>
                            </v-radio>
                          </v-radio-group>
                        </div>
                      </li>
                      <li>
                        Apakah benar status Sekolah tersebut
                        <strong>
                          {{ Number($getDeepObj(sekolah, 'sekolah.is_negeri')) === 1 ? 'Negeri' : 'Swasta' }}?
                        </strong>
                        <div>
                          <v-radio-group v-model="form['status_sesuai']['negeri']" row class="mt-0">
                            <v-radio value="1" color="green">
                              <template v-slot:label>
                                <div><strong class="green--text">Ya</strong></div>
                              </template>
                            </v-radio>
                            <v-radio value="0" color="red">
                              <template v-slot:label>
                                <div><strong class="red--text">Tidak</strong></div>
                              </template>
                            </v-radio>
                          </v-radio-group>
                        </div>
                      </li>
                      <li>
                        Apakah benar alamat Sekolah tersebut di
                        <strong>{{ $getDeepObj(sekolah, 'sekolah.alamat') }}?</strong>
                        <div>
                          <v-radio-group v-model="form['status_sesuai']['alamat']" row class="mt-0">
                            <v-radio value="1" color="green">
                              <template v-slot:label>
                                <div><strong class="green--text">Ya</strong></div>
                              </template>
                            </v-radio>
                            <v-radio value="0" color="red">
                              <template v-slot:label>
                                <div><strong class="red--text">Tidak</strong></div>
                              </template>
                            </v-radio>
                          </v-radio-group>
                        </div>
                      </li>
                    </ol>
                  </div>
                </div>
                <div v-else>
                  <v-alert text type="error">
                    <p class="body-1 text-bold mb-0">
                      Saat ini Anda belum bisa mengikuti seleksi program Sekolah Penggerak karena kemungkinan berikut:
                    </p>
                    <ul class="pl-0 black--text body-2">
                      <template v-if="syarat.kasek === false">
                        <li>
                          Anda belum terdata sebagai Kepala Sekolah Definitif berdasarkan data Dapodik. Jika Anda
                          sekarang bertugas sebagai Kepala Sekolah Definitif di sekolah dalam daerah sasaran namun
                          menerima informasi ini, silahkan melakukan pengkinian data Dapodik pada bagian
                          <b>JENIS PTK DAN TUGAS TAMBAHAN HARUS TERISI KEPALA SEKOLAH</b>. Pengkinian data Dapodik
                          maksimal 5 hari sebelum batas akhir pendaftaran.
                        </li>
                      </template>
                      <template v-if="syarat.sasaran === false">
                        <li v-if="$getDeepObj(syarat, 'data.luar')">
                          {{ $getDeepObj(syarat, 'data.luar') }}
                        </li>
                        <li v-else>
                          Sistem pendaftaran masih belum dibuka untuk daerah Anda karena masih menunggu nota kesepakatan
                          final antara PEMDA dan Kemendikbudristek. Jika nota kesepakatan sudah disepakati dua belah
                          pihak, maka sistem pendaftaran akan terbuka
                        </li>
                      </template>
                      <template v-if="syarat.kualifikasi === false">
                        <li>
                          Pendidikan terakhir Anda tidak memenuhi persyaratan minimal S1/D4. Jika pendidikan terakhir
                          Anda tidak sesuai mohon perbaharui data Anda di Dapodik.
                        </li>
                      </template>
                      <template v-if="syarat.jenjang === false">
                        <li>
                          Anda terdata di Dapodik tidak sebagai Kepala Sekolah pada jenjang PAUD, SD, SMP, SMA, atau
                          SLB.
                        </li>
                      </template>
                      <template v-if="syarat.paud === false">
                        <li>
                          Anda adalah Kepala Satuan Pendidikan Anak Usia Dini di bawah 5 tahun.
                        </li>
                      </template>
                    </ul>
                  </v-alert>
                </div>
              </template>
            </v-stepper-content>
            <v-stepper-content step="2" class="py-0">
              <h2 class="black--text">Informasi Dasar</h2>
              <p class="black--text pa-0 ma-0">
                Lengkapi informasi dasar Anda pada form yang tersedia. Pastikan
                <strong>Nomor Telepon Anda Aktif dan menggunakan email yang valid</strong>
              </p>
              <v-form ref="form" lazy-validation>
                <v-container class="pa-0 py-2">
                  <v-row>
                    <v-col v-if="false" cols="12" class="pb-0">
                      <v-subheader class="px-0 body-2 secondary--text" style="height: 24px">
                        Nomor Induk Kependudukan (NIK)<span class="red--text">*</span>
                      </v-subheader>
                      <v-text-field
                        dense
                        single-line
                        :rules="[(v) => !!v || 'NIK wajib diisi']"
                        v-mask="'################'"
                        type="text"
                        label="Nomor Induk Kependudukan (NIK)"
                        required
                        outlined
                        v-model="form['nik']"
                      />
                    </v-col>
                    <v-col cols="12" md="6" class="py-0">
                      <v-subheader class="px-0 body-2 secondary--text" style="height: 24px">
                        No.Telepon (Terhubung WA)<span class="red--text">*</span>
                      </v-subheader>
                      <v-text-field
                        dense
                        single-line
                        :rules="[(v) => !!v || 'No.Telepon wajib diisi']"
                        v-mask="'###############'"
                        type="text"
                        label="No.Telepon (Terhubung WA)"
                        required
                        outlined
                        v-model="form['no_wa']"
                      />
                    </v-col>
                    <v-col cols="12" md="6" class="py-0">
                      <v-subheader class="px-0 body-2 secondary--text" style="height: 24px">
                        Email<span class="red--text">*</span>
                      </v-subheader>
                      <v-text-field
                        dense
                        single-line
                        :rules="[
                          (v) => !!v || 'Alamat surel wajib diisi',
                          (v) => /.+@.+/.test(v) || 'Alamat surel harus valid',
                        ]"
                        type="text"
                        label="Alamat Surel"
                        required
                        outlined
                        v-model="form['alt_email']"
                    /></v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-stepper-content>
            <v-stepper-content step="3" class="py-0">
              <h2 class="black--text">Informasi Dasar</h2>
              <p class="black--text">
                Silahkan cek kembali secara teliti semua data yang sudah Anda isikan di bawah ini.
              </p>
              <v-row class="my-5 black--text">
                <v-col cols="12" class="py-0">
                  <h2 class="black--text">Data Personal dan Sekolah</h2>
                </v-col>
                <v-col cols="12" class="py-0">
                  <div><small class="caption info--text">Nama Lengkap</small></div>
                  {{ ptk.nama }}
                </v-col>
                <v-col cols="12" sm="12" md="6" class="pb-0">
                  <div><small class="caption info--text">Status Anda</small></div>
                  {{ $getDeepObj(sekolah, 'm_tugas.keterangan') }}
                </v-col>
                <v-col cols="12" sm="12" md="6" class="pb-0">
                  <template v-if="false">
                    <div><small class="caption info--text">NIK</small></div>
                    {{ $getDeepObj(form, 'nik') }}
                  </template>
                </v-col>
                <v-col cols="12" sm="12" md="6" class="pb-0">
                  <div><small class="caption info--text">Nama Sekolah</small></div>
                  {{ $getDeepObj(sekolah, 'nama') }}
                </v-col>
                <v-col cols="12" sm="12" md="6" class="pb-0">
                  <div><small class="caption info--text">Status Sekolah</small></div>
                  {{ Number($getDeepObj(sekolah, 'sekolah.is_negeri')) === 1 ? 'Negeri' : 'Swasta' }}
                </v-col>
                <v-col cols="12" class="pb-0">
                  <div><small class="caption info--text">Alamat Sekolah</small></div>
                  {{ $getDeepObj(sekolah, 'sekolah.alamat') }}
                  <br />
                  {{ $getDeepObj(sekolah, 'sekolah.m_kota.keterangan') }} -
                  {{ $getDeepObj(sekolah, 'sekolah.m_kota.m_propinsi.keterangan') }}
                </v-col>
                <v-col cols="12" sm="12" md="6" class="pb-0">
                  <div><small class="caption info--text">Nomor Telepon (Terhubung WhatsApp)</small></div>
                  {{ $getDeepObj(form, 'no_wa') }}
                </v-col>
                <v-col cols="12" sm="12" md="6" class="pb-0">
                  <div><small class="caption info--text">Email</small></div>
                  {{ $getDeepObj(form, 'alt_email') }}
                </v-col>
              </v-row>
            </v-stepper-content>
            <v-stepper-content step="4" class="py-0">
              <h2 class="black--text">Selamat!! Pendaftaran Berhasil</h2>
              <p class="body-2 black--text">
                Mohon terus memantau <i>e-mail</i> Bapak/Ibu, undangan mengikuti tahap seleksi akan kami kirimkan
                melalui surel(<i>e-mail</i>) Bapak/Ibu
              </p>
              <h3 class="info--text mb-2">PAKTA INTEGRITAS</h3>
              <h4 class="black--text">Informasi Pribadi</h4>
              <v-row class="black--text">
                <v-col cols="4" class="pb-0">Nama Lengkap</v-col>
                <v-col cols="8" class="pb-0">
                  : <strong>{{ ptk.nama }}</strong>
                </v-col>
                <v-col v-if="false" cols="4" class="py-0">NIK</v-col>
                <v-col v-if="false" cols="8" class="py-0">
                  : <strong>{{ form.nik }}</strong>
                </v-col>
                <v-col cols="4" class="py-0">SIMPKB ID</v-col>
                <v-col cols="8" class="py-0">
                  : <strong>{{ ptk.no_ukg }}</strong>
                </v-col>
                <v-col cols="4" class="py-0">Alamat Email</v-col>
                <v-col cols="8" class="py-0">
                  : <strong>{{ form.alt_email }}</strong>
                </v-col>
                <v-col cols="4" class="py-0">Nomor Telepon (WA)</v-col>
                <v-col cols="8" class="py-0">
                  : <strong>{{ form.no_wa }}</strong>
                </v-col>
                <v-col cols="4" class="pt-0">Jabatan</v-col>
                <v-col cols="8" class="pt-0">
                  : <strong>{{ $getDeepObj(sekolah, 'm_tugas.keterangan') }}</strong>
                </v-col>
              </v-row>
              <h4 class="mt-2 black--text">Informasi Instansi</h4>
              <v-row class="black--text mb-3">
                <v-col cols="4" class="pb-0">Satuan Pendidikan</v-col>
                <v-col cols="8" class="pb-0">
                  : <strong>{{ $getDeepObj(sekolah, 'nama') }}</strong>
                </v-col>
                <v-col cols="4" class="py-0">NPSN Satuan Pendidikan</v-col>
                <v-col cols="8" class="py-0">
                  : <strong>{{ $getDeepObj(sekolah, 'sekolah.npsn') }}</strong>
                </v-col>
                <v-col cols="4" class="py-0">Status Sekolah</v-col>
                <v-col cols="8" class="py-0">
                  : <strong>{{ Number($getDeepObj(sekolah, 'sekolah.is_negeri')) === 1 ? 'Negeri' : 'Swasta' }}</strong>
                </v-col>
                <v-col cols="4" class="py-0">Alamat Sekolah</v-col>
                <v-col cols="8" class="py-0">
                  : <strong>{{ $getDeepObj(sekolah, 'sekolah.alamat') }}</strong>
                </v-col>
              </v-row>
              <p class="black--text mb-1">
                menyatakan bahwa data yang tercantum dalam aplikasi pendaftaran dan seleksi sekolah penggerak sudah saya
                perikan kebenaran dan kemutakhiran datanya sesuai dengan fakta di lapangantanpa ada rekayasa
              </p>
              <p class="black--text">
                Saya bertanggung jawab jika dikemudian hari ditemukan ketidaksesuaian antara data yang tercantum dengan
                fakta, saya siap menerima sanksi sesuai dengan ketentuan peraturan perundang-undangan
              </p>
              <v-checkbox class="mt-0 mb-5" v-model="isChecked" hide-details>
                <template v-slot:label>
                  <div class="black--text body-2">
                    Dengan ini saya memahami dan menyetujui semua kententuan terkait Pendaftaran Program Sekolah
                    Penggerak
                  </div>
                </template>
              </v-checkbox>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-row no-gutters v-if="step < 4">
          <v-col cols="12" class="px-2">
            <div class="text-right">
              <template v-if="step === 1">
                <v-btn
                  color="info"
                  elevation="0"
                  :disabled="
                    !(form['status_sesuai'] && form['status_sesuai']['kasek']) ||
                      !(form['status_sesuai'] && form['status_sesuai']['negeri']) ||
                      !(form['status_sesuai'] && form['status_sesuai']['alamat'])
                  "
                  @click="onNext"
                >
                  Selanjutnya
                </v-btn>
              </template>
              <template v-if="step === 2">
                <v-btn text elevation="0" @click="onBack">
                  Kembali
                </v-btn>
                <v-btn color="info" elevation="0" @click="onNext">
                  Selanjutnya
                </v-btn>
              </template>
              <template v-if="step === 3">
                <div class="text-left">
                  <h4>Apakah data yang ditampilkan di atas sudah benar semua?</h4>
                  <div class="mt-2">
                    <v-btn color="red" class="mr-2" dark @click="onBack">Masih terdapat data yang salah</v-btn>
                    <v-btn color="green" dark @click="onNext">Semua data sudah benar</v-btn>
                  </div>
                </div>
              </template>
            </div>
          </v-col>
        </v-row>
        <template v-else>
          <v-spacer></v-spacer>
          <div class="text-right">
            <v-btn color="info" elevation="0" @click="finish" :disabled="!isChecked">OK</v-btn>
          </div>
        </template>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex';
export default {
  name: 'PopupDaftarKasek',
  props: {
    instansiKasek: {
      type: Array,
      default: () => [],
    },
    ptk: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      dialog: false,
      isChecked: false,
      step: 1,
      sekolah: null,
      infoDetails: null,
      form: {},
    };
  },
  computed: {
    ...mapState('preferensi', {
      peserta_cadangan: (state) => state.data?.peserta_cadangan ?? {},
    }),

    syarat() {
      return this.infoDetails?.syarat ?? {};
    },
    allowDaftar() {
      const syaratFalse = Object.values(this.syarat).includes(false);
      return !syaratFalse ?? false;
    },
  },
  methods: {
    ...mapActions('preferensi', ['cekSyarat', 'ajuan']),

    open() {
      this.step = 1;
      this.dialog = true;

      this.$set(this, 'form', {});
      this.$set(this.form, 'status_sesuai', {});
      this.initForm();
    },

    close() {
      this.dialog = false;
    },

    finish() {
      this.$emit('reload');
      this.close();
    },

    async save() {
      const params = this.form;
      this.ajuan({ params }).then(() => {
        this.step += 1;
      });
    },

    onChangeSekolah(sekolahId) {
      const sekolah = this.instansiKasek.filter((sekolah) => {
        return +sekolah.sekolah_id === +sekolahId;
      });
      const params = {
        sekolah_id: sekolahId,
        k_tugas: sekolah[0] && sekolah[0]['k_tugas'],
      };

      this.sekolah = (sekolah && sekolah[0]) || {};
      this.form['k_tugas'] = params['k_tugas'];
      this.cekSyarat({ tipe: 'peserta', params }).then(({ data }) => {
        this.infoDetails = data;
      });
    },

    onBack() {
      if (this.step === 1) {
        this.$notifikasi(
          [
            '<h2 class="body-2 black--text my-3">Data DAPODIK Tidak Sesuai</h2>',
            '<p class="black--text body-2">' +
              'Data Anda saat ini yang terhubung dengan <b>DAPODIK belum sesuai</b>. Segera lakukan ' +
              '<b>Perbarui Data</b> Anda sesuai dengan data terbaru.</p>',
            '<p class="black--text body-2">' +
              'Anda dapat melakukan perubahan data dapodik melalui <b>Operator Sekolah</b> atau <b>Operator Dinas</b>. ' +
              'Apabila data sudah termutahirkan di dapodik maka otomatis di SIMPKB akan ikut berubah.</p>',
            '<p class="black--text body-2">Estimasi waktu update di dapodik adalah <b>maksimal 2x24 jam</b> ' +
              'setelah operator melakukan perubahan</p>',
            '<p class="black--text body-2"><strong>Jika data telah diperbaiki dan valid, silakan ulangi proses pendaftaran</strong></p>',
          ].join(''),
          'Informasi',
          { btnColor: 'secondary' }
        );
        return;
      }
      this.step -= 1;
    },

    async onNext() {
      const statusSesuai = Object.values(this.form['status_sesuai'] || {});
      const isSalahDapodik = statusSesuai.includes('0');

      switch (this.step) {
        case 1:
          if (!isSalahDapodik) {
            this.step += 1;
          } else {
            this.$emit('lapor', this.form);
          }
          break;
        case 2:
          if (!this.$refs.form.validate()) return;
          this.step += 1;
          break;
        case 3:
          this.save();
          break;
      }
    },

    onDaftar() {
      this.daftar({ tipe: this.tipe, params: this.form })
        .then(() => {
          this.step += 1;
        })
        .catch((err) => {
          this.$error(err);
        });
    },

    initForm() {
      if (!Object.keys(this.peserta_cadangan).length) return;
      const keys = ['nik', 'no_wa', 'alt_email'];

      keys.forEach((key) => {
        if (key === 'alt_email') {
          this.$set(this.form, key, this.$getDeepObj(this.peserta_cadangan, 'ptk.alt_email'));
        } else {
          this.$set(this.form, key, this.$getDeepObj(this.peserta_cadangan, key));
        }
      });
    },
  },
};
</script>
